import React from 'react'
import parse from 'html-react-parser'
import PropertyCard from './cards/property'
import Slider from 'react-slick'
import { RightArrow, ShortArrowRight, RightCurledArrow } from './icons'
import Link from '../utils/link'
import Select from 'react-select'
import { Fade } from 'react-reveal'

import useShowcaseQuery from "../hooks/use-showcase-query"

let categories = [
  { label: "For Sale", value: 0 },
  { label: "Recent Sales", value: 1 },
  { label: "For Lease", value: 2 },
]

const PropertyShowcase = ({ title }) => {
  const [activeTab, setActiveTab] = React.useState(0)
  const [activeTabLabel, setActiveTabLabel] = React.useState('For Sale')

  const showcaseLink = [
    '/for-sale/',
    '/sold/',
    '/for-lease/',
  ]

  const { buy, sold, lease } = useShowcaseQuery()

  const settings = {
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    arrows: false,
    cssEase: 'ease',
    swipe: true,
    pauseOnHover: false,
  }

  const selectChange = (option) => {
    setActiveTab(option.value)
    setActiveTabLabel(option.label)
  }


  return (
    <section className='showcase'>
      <div className='showcase__inner'>
        <Fade bottom distance='40px'>
          { title &&<h1>{parse(title)}</h1> }
        </Fade>
      </div>
      <div className='showcase__filter'>
        <Select
          options={categories}
          onChange={selectChange}
          openMenuOnFocus={true}
          isSearchable={false}
          id="category"
          name="category"
          value={activeTabLabel}
          placeholder={activeTabLabel}
          className="react-select-container"
          classNamePrefix="react-select"
          sty
          // ref={node => this.category = node}
        />
        <ul>
          <li>
            <button type='button' onClick={() => setActiveTab(0)} className={activeTab === 0 ? 'active' : ''}>
              For Sale
            </button>
          </li>
          <li>
            <button type='button' onClick={() => setActiveTab(1)} className={activeTab === 1 ? 'active' : ''}>
              Recent Sales
            </button>
          </li>
          <li>
            <button type='button' onClick={() => setActiveTab(2)} className={activeTab === 2 ? 'active' : ''}>
              For Lease
            </button>
          </li>
        </ul>
        <Link to={showcaseLink[activeTab]} className='showcase__link'>
          View More
          <ShortArrowRight color='#0F2130' />
        </Link>
      </div>
      <Fade bottom distance='40px'>
        <div className='showcase__tabs'>
          <div className={`showcase__tab ${activeTab === 0 ? 'active' : ''}`}>
            <Slider { ...settings } className='showcase__slider'>
              { buy?.map((el) => {
                return (<PropertyCard showcase={true} key={el.id} {...el} postType='property' />)
              }) }
            </Slider>
          </div>
          <div className={`showcase__tab ${activeTab === 1 ? 'active' : ''}`}>
            <Slider { ...settings } className='showcase__slider'>
              { sold?.map((el) => {
                return (<PropertyCard showcase={true} key={el.id} {...el} postType='property' />)
              }) }
            </Slider>
          </div>
          <div className={`showcase__tab ${activeTab === 2 ? 'active' : ''}`}>
            <Slider { ...settings } className='showcase__slider'>
              { lease?.map((el) => {
                return (<PropertyCard showcase={true} key={el.id} {...el} postType='rental' />)
              }) }
            </Slider>
          </div>
        </div>
      </Fade>
    </section>
  );
}

export default PropertyShowcase